import { GET_CURRENT_USER, GET_USER_MANAGER, IS_LOGGED, GET_DATA_FAILED, GET_DATA_SUCCESS } from './types';
import { apiAddress } from "../GlobalConst/globalConst";
import Api from '../services/Api'

//For web based auth - not used at this moment
export const login = () => dispatch => {
    Api.get('/User/IsLogged')
    .then(res => res.data)
    .then(isLogged => {
        if(!isLogged) {
            window.location.assign(`${apiAddress}/User/Login?redirectUri=${window.location.href}`);
        }
        else {
            dispatch({
                type: IS_LOGGED,
                loggingInfo: isLogged,
            });
            dispatch({
                type: GET_DATA_SUCCESS
            });
        }
    })
    .catch(err => {
        dispatch({
            type: GET_DATA_FAILED,
            payload: 'Cannot contact backend server.'
        });
    });
}

export const getCurrentUser = () => dispatch => {
    Api.get('User')
    .then(res => res.data)
    .then(user => {
        dispatch({
            type: GET_CURRENT_USER,
            user
        });
    });
}

export const getUserManager = (userId) => dispatch => {
    Api.get(`/User/Manager?userId=${userId}`)
    .then(res => res.data)
    .then(user => {
        dispatch({
            type: GET_USER_MANAGER,
            manager: user
        });
    })
}


// WEBPACK FOOTER //
// ./src/actions/userActions.js